import React from 'react';
import { X, ShieldCheck } from 'lucide-react';
import { questionsFor } from './agreementContent';

interface Props {
  /** Rol del AUTOR del acuerdo que se está leyendo. */
  role: 'mentee' | 'mentor';
  answers: Record<string, string> | null;
  name: string;
  onClose: () => void;
}

/** Vista de solo lectura del Acuerdo de Mentoría de la contraparte (sus respuestas). */
const AgreementModal: React.FC<Props> = ({ role, answers, name, onClose }) => {
  const questions = questionsFor(role);
  const firstName = (name || '').split(' ')[0] || name;
  return (
    <div className="feedback-modal-overlay" onClick={onClose}>
      <div className="feedback-modal ac-read-modal" onClick={e => e.stopPropagation()}>
        <button className="sf-close" onClick={onClose} aria-label="Cerrar"><X size={18} /></button>
        <div className="ac-read-eyebrow"><ShieldCheck size={14} /> Acuerdo de Mentoría · {role === 'mentor' ? 'Mentor' : 'Mentee'}</div>
        <h3 className="ac-read-title">El compromiso de {firstName}</h3>
        <p className="ac-read-sub">Lo que {firstName} respondió al firmar su acuerdo. Léelo para alinear expectativas.</p>
        <div className="ac-read-list">
          {questions.map((q, i) => (
            <div className="ac-read-item" key={q.id}>
              <div className="ac-read-q"><span className="ac-read-num">0{i + 1}</span> {q.text}</div>
              <div className="ac-read-a">{answers?.[q.id]?.trim() || '—'}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AgreementModal;
